<template>
  <div id="resume-list-template">
    <div class="job-search-condition-board">
      <div class="sub-text">{{member.name}}님은</div>
      <div class="main-text-wrap">
        <span class="text">
          <template v-if="jobSearchStatusLabel">
            현재 <strong>"{{jobSearchStatusLabel}}"</strong> 상태입니다.
          </template>
          <template v-else>
            구직상태를 선택해 주세요.
          </template>
        </span>
        <button type="button" class="btn btn-gray btn-xsm" @click="showJobSearchStatusModal">
          구직상태 변경하기
        </button>
      </div>
      <div class="job-keyword-wrap">
        <div class="job-keyword"><span>주된 직업군</span> {{ member.occuPation }}</div>
        <div class="job-keyword"><span>주소지</span> {{ district }}</div>
      </div>
    </div>
    <div class="box-type bg-primary type-left mt-24">
      <ul class="list-type-dot">
        <li>구직상태가 “구직 희망 중” 또는 “이직 고려 중”일 경우 일자리 몽땅에서 제공하는 일자리 추천을 받으실 수 있습니다.</li>
        <li class="mt-16">“주된 직업 군”과 “거주지(주소지)”는 일자리 추천 시 활용되는 정보이므로 맞춤 일자리 추천을 위해 정확히 입력해 주세요.
          <a href="/mypage-info.do" class="btn btn-secondary btn-sm">회원정보 수정</a>
        </li>
      </ul>
    </div>
    <!-- //page-title-wrap -->
    <div class="content-section">
      <div class="resume-list-header">
        <h3>나의 이력서 목록</h3>
        <p class="resume-count">총 {{activeCount}}건의 작성된 이력서가 있습니다.</p>
        <button class="btn btn-line-box btn-sm btn-updata" @click="updateAllToday">
          <i class="ico ico-refresh"></i>
          오늘 날짜로 업데이트
        </button>
      </div>
      <section class="resume-list-section">
        <div class="resume-card" v-for="(resume, index) in resumeList" :key="resume.indbankNo">
          <div class="resume-card-header">
            <div class="last-updata-text">최근 업데이트 : {{resume.formattedChgDate}}</div>
            <div class="resume-card-body-top">
              <h4 class="resume-title">{{ resume.title }}</h4>
              <div class="resume-controls">
                <div class="representative-switch">
                  <!-- <span class="switch-label" v-if="resume.mainYn == 'Y'">대표</span> -->
                  <label class="switch-container">
                    <input type="radio" id="switch1" name="representative-resume" class="switch-input" :checked="resume.mainYn === 'Y'" @change="changeMainResume(resume.indbankNo)" :disabled="resumeList.length === 1" title="switch1 선택">
                    <div class="switch-bg"><div class="switch-handle"></div></div>
                  </label>
                  대표
                </div>
                <div class="more-list" :ref="`moreList${resume.indbankNo}`">
                  <button class="btn btn-only-icon btn-more" aria-label="더보기" @click="toggleMoreList(resume.indbankNo, $event)" title="더보기"><i class="ico ico-h-dot"></i></button>
                  <ul class="more-list-detail" :class="{ 'show': showMoreList === resume.indbankNo }">
                    <li class="btn btn-line-box btn-sm cpy" style="display: inline-grid;height: 66px;">
                      <button @click="copyResume(resume)">복사하기</button>
                      <button @click="delResume(resume)" :disabled="resume.mainYn === 'Y'">삭제하기</button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="resume-card-body">
            <div class="resume-card-body-main">
              <div class="progress-section">
                <div class="progress-data">
                  <div class="progress-text">
                    완성도
                  </div>
                  <div class="progress-bar-container">
                    <div class="progress-bar" :style="getProgressWidth(resume.completionRate)"></div>
                  </div>
                  <div class="percentage">{{ Math.round(resume.completionRate * 100) }}%</div>
                </div>
                <div class="progress-subtext">(높은 이력서 완성도는 더 많은 맞춤형 일자리 추천을 받으실 수 있습니다.)</div>
              </div>
              <div class="keywords-section">
                <p class="keywords-title">이력서 키워드</p>
                <div class="keywords-tag-list">
                  <button type="button" class="keyword-tag" v-for="(keyword, index) in resume.keywords" :key="index">{{ keyword }}</button>
                </div>
              </div>
            </div>
          </div>
          <div class="resume-card-footer">
            <button class="btn btn-secondary btn-md" @click="showPreview(resume.indbankNo)">미리보기</button>
            <button class="btn btn-secondary btn-md" @click="printResume(resume.indbankNo)">출력</button>
            <button class="btn btn-primary btn-md" @click="modify(resume.indbankNo)">
              <i class="ico ico-pen-wt"></i>
              수정하기
            </button>
          </div>
        </div>

        <!-- Add Resume Card -->
        <div class="flex flex-direction align-items-center">
          <button type="button" class="add-resume-icon" @click="addResume">
            <i class="ico ico-plus48"></i>
            <p>이력서 추가하기</p>
          </button>
          <p>이력서는 최대 3개까지 작성하실 수 있습니다.</p>
        </div>
      </section>
      <div class="box-type bg-primary type-left mt-40">
        <ul class="list-type-dot">
          <li>이력서 등록은 최대 3개까지 가능하며, 지원 시 이력서를 선택하여 지원하실 수 있습니다.</li>
          <li>대표이력서로 선택된 이력서는 지원 시 자동으로 선택되며, 지원 시 다른 이력서를 선택하여 지원하실 수 있습니다.</li>
          <li>‘오늘날짜로 업데이트’버튼을 눌러 작성한 모든 이력서의 최근 업데이트일을 오늘 날짜로 변경하실 수 있습니다.</li>
        </ul>
      </div>
    </div>
    <job-search-status-modal :jobSearchStatusModal="jobSearchStatusModal" :jobSearchStatus="member.jobSearchStatus" @update:jobSearchStatus="closeJobSearchStatusModal"></job-search-status-modal>
    <preview-modal :previewModal="previewModal" :indbankNo="selectedResume.indbankNo" @closePreviewModal="closePreview" @openDetail="modify"></preview-modal>
    <detail-modal :detailModal="detailModal" :resume="selectedResume" :district="district" @closeDetailviewModal="closeDetailview" @update:resumeList="getResumeList"></detail-modal>
    <introduction-ex-one-modal></introduction-ex-one-modal>
    <introduction-ex-twe-modal></introduction-ex-twe-modal>

  </div>
</template>

<script>
import Axios from 'axios';
import JobSearchStatusModal from '../member/JobSearchStatusModal.vue';
import PreviewModal from './Preview.vue';
import DetailModal from './Detail.vue';
import IntroductionExOneModal from './IntroductionEx1.vue';
import IntroductionExTweModal from './IntroductionEx2.vue';

const jobSearchStatus = {
  SEEKING: '구직희망중',
  NOT_SEEKING: '구직의사없음',
};

export default {
  name: 'resume-list-template',
  props: ['member'],
  components: {
    JobSearchStatusModal,
    PreviewModal,
    DetailModal,
    IntroductionExOneModal,
    IntroductionExTweModal,
  },
  data() {
    return {
      activeCount: 0,
      canCreateNew: true,
      resumeList: [],
      jobSearchStatusModal: false,
      jobSearchStatusLabel: jobSearchStatus[this.member.jobSearchStatus],
      previewModal: false,
      detailModal: false,
      selectedResume: { },
      district: '',
      showBtnBox: false,
      showMoreList: null,
    };
  },
  methods: {
    showJobSearchStatusModal() {
      $('body').addClass('modal-open');
      this.jobSearchStatusModal = true;
    },
    closeJobSearchStatusModal(code) {
      this.member.jobSearchStatus = code;
      this.jobSearchStatusModal = false;
      this.getJobSearchStatusLabel();
    },
    showPreview(no) {
      $('body').addClass('modal-open');
      this.selectedResume = {};
      this.resumeList.forEach((item) => {
        if (item.indbankNo === no) {
          this.selectedResume = item;
        }
      });
      if (JSON.stringify(this.selectedResume) !== '{}') this.previewModal = true;
    },
    closePreview() {
      this.previewModal = false;
    },
    modify(no) {
      this.selectedResume = {};
      this.resumeList.forEach((item) => {
        if (item.indbankNo === no) {
          this.selectedResume = item;
        }
      });
      if (JSON.stringify(this.selectedResume) !== '{}') this.showDetailModal();
    },
    printResume(indbankNo) {
      window.open(`/resume-print.do?indbankNo=${indbankNo}`, '_blank');
    },
    showDetailModal() {
      $('body').addClass('modal-open');
      this.detailModal = true;
    },
    closeDetailview() {
      this.detailModal = false;
      this.getResumeList();
    },
    getResumeList() {
      Axios.get('/api/idb/list')
        .then((response) => {
          const success = response.data.success;
          if (success === 'R') {
            this.resumeList = response.data.data.data.map((item) => {
              const newKeywords = item.keywords.filter(keyword => keyword !== null);
              return {
                ...item,
                keywords: newKeywords,
              };
            });
            this.activeCount = response.data.data.activeCount;
            this.canCreateNew = response.data.data.canCreateNew;
          }
        }).catch((e) => {
          console.log('error', e);
          alert(e.data.msg);
        });
    },
    getProgressWidth(rate) {
      const progressWidth = Math.floor(rate * 100);
      return { width: `${progressWidth}%` };
    },
    changeMainResume(indbankNo) {
      // 대표 이력서 변경
      if (!confirm('해당 이력서를 대표이력서로 설정 하시겠습니까')) return false;

      Axios.post(`/api/idb/${indbankNo}/setMain`).then((response) => {
        if (response.data.success === 'U') {
          alert(response.data.message);
          location.reload();
        }
      }).catch((e) => {
        alert(e.response.data.message);
      });

      return true;
    },
    addResume() {
      if (this.canCreateNew) {
        this.selectedResume = {
          completionRate: 0,
        };
        this.showDetailModal();
      } else {
        alert('이력서는 3개까지 저장 가능합니다');
      }
    },
    copyResume(resume) {
      if (this.canCreateNew) {
        const params = {
          resumeTitle: `${resume.title}-사본`,
        };
        Axios.post(`/api/idb/${resume.indbankNo}/copy`, { ...params })
          .then((response) => {
            if (response.data.success === 'C') {
              alert(response.data.message);
              this.selectedResume = response.data.data;
              this.showDetailModal();
              this.getResumeList();
            }
          });
      } else {
        alert('이력서는 3개까지 저장 가능합니다');
      }
    },
    delResume(resume) {
      if (resume.mainYn !== 'Y' && confirm('해당 이력서를 삭제하시겠습니까?')) {
        Axios.post(`/api/idb/${resume.indbankNo}/delete`).then((response) => {
          if (response.data.success === 'D') {
            alert(response.data.message);
            this.selectedResume = {};
            this.getResumeList();
          }
        }).catch((e) => {
          alert(e.response.data.message);
        });
      }
    },
    updateAllToday() {
      Axios.post('/api/idb/updateAllDatesToToday')
        .then((response) => {
          if (response.data.success === 'C') {
            alert(response.data.msaage);
            this.getResumeList();
          }
        }).catch((e) => {
          alert(e.response.data.message);
        });
    },
    getJobSearchStatusLabel() {
      this.jobSearchStatusLabel = jobSearchStatus[this.member.jobSearchStatus];
    },
    getDistrict() {
      const addr1Array = this.member.addr1.split(' ');
      this.district = `${addr1Array[0]} ${addr1Array[1]}`;
    },
    toggleMoreList(no, event) {
      event.stopPropagation();
      this.showMoreList = this.showMoreList === no ? null : no;
    },
    handleClickOutside(event) {
      // 더보기 메뉴가 열려있을 때만 처리
      if (this.showMoreList !== null) {
        const moreListElement = this.$refs[`moreList${this.showMoreList}`];
        if (moreListElement && !moreListElement[0].contains(event.target)) {
          this.showMoreList = null;
        }
      }
    },
  },
  mounted() {
    this.getResumeList();
    this.getDistrict();
    // 외부 클릭 감지를 위한 이벤트 리스너 추가
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // 컴포넌트 파괴 시 이벤트 리스너 제거
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
.more-list-detail {
  display: none;
}

.more-list-detail.show {
  display: block;
}
</style>



// WEBPACK FOOTER //
// resumeList.vue?d175f008